import React from 'react'
import { useSelector } from 'react-redux'
import cx from 'clsx'
// Components
import { Social } from '~2023/components/Social'
// Styles
import useStyles from './Footer.style'
// Hooks
import useSiteMeta from '~2023/hooks/useSiteMeta'

const filterSelector = (state) => state.filter

const Footer = ({
  detailFandomRank,
  detailFandomTitle,
  detailFilterTitle,
  twitterHandle,
}) => {
  const classes = useStyles()
  const siteMeta = useSiteMeta()
  const { siteUrl, title: siteTitle } = siteMeta

  const {
    data: { year: filterYear },
    fandom: { rank: fandomRank },
  } = useSelector(filterSelector)

  const shareUrl =
    `undefined` !== typeof window ? window.location.href : siteUrl
  const shareTitle = siteTitle

  return (
    <footer
      className={cx(classes.footer, !!fandomRank && 'footer--fandom')}
      component="footer"
      itemScope
      itemType="http://schema.org/WPFooter"
      role="contentinfo"
    >
      <div>
        <div className={cx(classes.siteSharingWrap)}>
          <p className={cx(classes.siteSharingText)}>Share This</p>
          <ul className={cx(classes.siteSharing)}>
            <Social
              url={shareUrl}
              title={shareTitle}
              filterYear={filterYear}
              detailFandomRank={detailFandomRank}
              detailFandomTitle={detailFandomTitle}
              detailFilterTitle={detailFilterTitle}
              twitterHandle={twitterHandle}
            />
          </ul>
        </div>
      </div>
    </footer>
  )
}

export default Footer
